import { all } from 'redux-saga/effects'

import interviewRequestsSagas from '../../InterviewRequests/sagas'
import candidateListSagas from '@/CandidateListES/redux/sagas'
import candidateDetailSagas from '../../CandidateDetails/redux/sagas'
import positionsDashboardSagas from '../../PositionsDashboard/redux/sagas'
import hiringAnalyticsSagas from '../../HiringAnalytics/sagas'
import awaitingKickOffSagas from '../../AwaitingKickOff/sagas/awaitingKickOff'
import watchAnalyticsSagas from './analytics'
import watchSessionsSagas from './sessions'

export default function* rootSaga() {
  yield all([
    watchAnalyticsSagas(),
    watchSessionsSagas(),
    ...interviewRequestsSagas(),
    ...candidateDetailSagas(),
    ...candidateListSagas(),
    ...positionsDashboardSagas(),
    ...hiringAnalyticsSagas(),
    ...awaitingKickOffSagas(),
  ])
}
